import {combine} from 'effector';
import {createGate} from 'effector-react';

import {fetchDocumentsDetail} from 'api/documents';
import {rootDomain} from 'core/rootDomain';
import {DocumentDetail} from 'types/documents';

const domain = rootDomain.createDomain('DocumentsDetailDomain');
export const DocumentsDetailGate = createGate<{id: string}>('DocumentsDetailGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchCommonDataFx',
    handler: fetchDocumentsDetail,
});

export const commonData$ = domain.createStore<DocumentDetail | null>(null);

export const commonDataState$ = combine({
    data: commonData$,
    isLoading: fetchDataFx.pending,
});
